import React from "react";
import { ThemeProvider } from "react-bootstrap";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LayoutComponent from "./pages/layout";
import HomePage from "./pages/homepage";
import "./App.css";
import "./i18n";
import { FirebaseAnalytics } from "./analytics";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <FirebaseAnalytics />
          <Routes>
            <Route
              path="/"
              element={
                <LayoutComponent>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/it"
              element={
                <LayoutComponent>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/en"
              element={
                <LayoutComponent>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/fr"
              element={
                <LayoutComponent>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/de"
              element={
                <LayoutComponent>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/es"
              element={
                <LayoutComponent>
                  <HomePage />
                </LayoutComponent>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}
export default App;
